
import { defineComponent, ref, watch, nextTick, PropType } from "vue";
import Button from "@/components/UI/Button.vue";

export default defineComponent({
  name: "FreeAnswer",
  components: { Button },

  props: {
    text: String,
    index: Number,
    customAnswerRequired: Boolean,
    type: {
      type: String as PropType<"ONE_PAGE" | undefined>,
      required: false,
    },
    currentLang: {
      type: String,
      required: true,
    },
  },

  emits: ["answersFields", "next-question"],

  setup(props, { emit }) {
    const customAnswer = ref<string>("");

    const customInp = () => {
      const answer = customAnswer.value.trim();
    };

    watch(
      () => customAnswer.value,
      (v: string) => {
        if (props.type !== "ONE_PAGE") {
          emit("answersFields", props.index, {
            customAnswer: v,
          });
        }
      }
    );

    const sendAnswer = async () => {
      await nextTick();
      emit("answersFields", props.index, {
        customAnswer: customAnswer.value.trim(),
      });

      emit("next-question");
    };

    return {
      customAnswer,
      customInp,
      sendAnswer,
    };
  },
});
